import React, { useState, useEffect } from "react";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import UploadMultiFile from "../../GenericComponent/UploadMultiFile";
import ChiTietCuaHangApi from "../../../service/chiTietCuaHangApi";

export const ThongTinTicket = ({
  currentForm,
  datanew,
  update,
  AnhTicket,
  updateAnhTicket,
  errors,
  setErrors
}) => {

  const [nameCode, setNameCode] = React.useState("");
  useEffect(() => {
    ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
      setNameCode(response.data.Code);
    });
  }, []);

  const updateTextValue = (field) => (e) => {
    update({
      ...datanew,

      [field]: e.target.value,
    });

    if (e.target.value === "") {
      setErrors({
        ...errors,
        tenTaiSan: "Nhập tên ticket!",
      });
    } else {
      setErrors({
        ...errors,
        tenTaiSan: "",
      });
    }
  };

  return (
    <>
      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-12">
            <h4 className="color-xanh-bold">
             Thông tin ticket
            </h4>
          </div>
        </div>
      </div>
      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-8">
            <TextInputOnRow labelClass="label-control color7-bold" inputClass="form-control input-sm" wrapperClass="form-group" labelText="Tiêu đề" starRed="*"
              inputProps={{
                name: "TieuDe",
                onChange: updateTextValue("TieuDe"),
                value: datanew.TieuDe,
              }}
            ></TextInputOnRow>
            {errors.TieuDe && (
              <span className="canh-bao-red">{errors.TieuDe}</span>
            )}
          </div>


          <div className="col-md-4">
            <div className="form-group">
              <label className="label-control color7-bold">Chức năng</label>
              <select
                class="form-control input-sm"
                value={datanew.ChucNang}
                onChange={updateTextValue("ChucNang")}
              >
                <option value="CamDo">Cầm đồ</option>
                <option value="TinChap">Tín chấp</option>
                <option value="TraGop">Trả góp</option>
                <option value="Khac">Khác</option>
              </select>
              {errors.ChucNang && (
                <span className="canh-bao-red">{errors.ChucNang}</span>
              )}
            </div>

          </div>

          <div className="col-md-8">
            <TextInputOnRow labelClass="label-control color7-bold" inputClass="form-control input-sm" wrapperClass="form-group" labelText="Mô tả" starRed="*"
              inputProps={{
                name: "MoTa",
                onChange: updateTextValue("MoTa"),
                value: datanew.MoTa,
              }}
            ></TextInputOnRow>
            {errors.MoTa && (
              <span className="canh-bao-red">{errors.MoTa}</span>
            )}
          </div>
          {/* <div className="col-md-4">
            <TextInputOnRow labelClass="label-control" inputClass="form-control input-sm" wrapperClass="form-group" labelText="Ngày tạo"
              inputProps={{
                name: "NgayTao",
                onChange: updateTextValue("NgayTao"),
                value: datanew.NgayTao,
              }}
            ></TextInputOnRow>
            {errors.NgayTao && (
              <span className="canh-bao-red">{errors.NgayTao}</span>
            )}
          </div> */}
        </div>
      </div>
      <div className="col-md-12 mt-1">
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <UploadMultiFile
                Files={AnhTicket}
                onChange={updateAnhTicket}
                Code={nameCode}
              ></UploadMultiFile>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
